<article class="action-card" [class.compact]="compact" [class.is-pending]="action.status === 'pending'" [attr.aria-labelledby]="headingId">
  <p class="ac-meta">
    <span>{{header}}</span>
    <span *ngIf="action.client && !action.client.verified" class="trust unverified"><i class="pi pi-exclamation-triangle" aria-hidden="true"></i> non vérifiée</span>
  </p>
  <div class="ac-heading">
    <span class="ac-type"><i class="pi pi-shield" aria-hidden="true"></i>{{typeLabel}}</span>
    <span class="ac-status" [ngClass]="'tone-' + tone">{{status}}</span>
  </div>
  <h2 *ngIf="!compact" [id]="headingId" class="ac-title">{{action.title}}</h2>
  <h3 *ngIf="compact" [id]="headingId" class="ac-title">{{action.title}}</h3>
  <p *ngIf="action.targetLabel && action.targetLabel !== action.title" class="ac-target">{{action.targetLabel}}</p>
  <p *ngIf="approver" class="ac-approver"><i class="pi pi-user" aria-hidden="true"></i>{{approver}}</p>

  <p *ngIf="action.effects.length || reversible" class="ac-effects">
    <span *ngIf="action.effects.length" class="effects-label">Effets :</span>
    <span *ngFor="let effect of action.effects; let last = last; trackBy: trackIndex" class="effect">{{effect}}<span *ngIf="!last" aria-hidden="true"> · </span></span>
    <strong *ngIf="reversible" class="reversible" [class.irreversible]="action.irreversible === true">{{reversible}}</strong>
  </p>

  <!-- Alerts: at the top, in pink, never folded nor hidden (03-APPROBATION §5.3) -->
  <div *ngIf="action.alerts.length" class="ac-alerts" role="alert">
    <p *ngFor="let alert of action.alerts; trackBy: trackIndex" class="ac-alert"><i class="pi pi-exclamation-triangle" aria-hidden="true"></i><span>{{alert.message}}</span></p>
  </div>

  <section *ngIf="!compact && action.recipients.length" class="ac-recipients" [attr.aria-label]="'Destinataires (' + action.recipients.length + ')'">
    <h4 class="ac-section-title">Destinataires (adresses figées)</h4>
    <ul>
      <li *ngFor="let item of action.recipients; trackBy: trackKey">
        <strong>{{item.name}}</strong>
        <span class="address">{{item.to || 'adresse absente'}}</span>
        <span *ngIf="item.lots.length" class="lots">Lots : {{item.lots.join(', ')}}</span>
      </li>
    </ul>
    <p *ngIf="action.ccMembers.length" class="ac-cc">Copie interne pour information : {{action.ccMembers.join(', ')}}</p>
  </section>

  <section *ngIf="!compact && recipient as current" class="ac-preview" aria-label="Aperçu exact des e-mails">
    <h4 class="ac-section-title">Aperçu exact</h4>
    <div *ngIf="action.recipients.length > 1" class="preview-tabs" role="tablist" aria-label="Destinataire de l’aperçu">
      <button *ngFor="let item of action.recipients; let index = index; trackBy: trackKey" type="button" role="tab" class="preview-tab"
        [class.selected]="index === selected" [attr.aria-selected]="index === selected" [attr.tabindex]="index === selected ? 0 : -1"
        [attr.aria-controls]="headingId + '-preview'" (click)="select(index)" (keydown)="tabKey($event, index)">{{item.name}}</button>
    </div>
    <div class="preview-panel" [id]="headingId + '-preview'" [attr.role]="action.recipients.length > 1 ? 'tabpanel' : null">
      <dl class="mail-headers">
        <div *ngFor="let row of current.headers; trackBy: trackIndex" class="mail-header"><dt>{{row.label}}</dt><dd>{{row.value}}</dd></div>
      </dl>
      <p *ngIf="current.htmlTooLarge" class="hint">Cet e-mail est trop volumineux pour être affiché ici.</p>
      <app-agent-mail-preview *ngIf="!current.htmlTooLarge" [html]="current.html" [label]="'Aperçu de l’e-mail pour ' + current.name"></app-agent-mail-preview>
    </div>
  </section>

  <ul *ngIf="!compact && action.facts.length" class="ac-facts" aria-label="Faits">
    <li *ngFor="let fact of action.facts; trackBy: trackIndex">{{fact}}</li>
  </ul>

  <section *ngIf="!compact && action.deletions as deletions" class="ac-deletions" aria-label="Éléments supprimés">
    <p *ngIf="deletions.summary" class="deletions-summary">{{deletions.summary}}</p>
    <ul *ngIf="deletions.items.length"><li *ngFor="let item of deletions.items; trackBy: trackIndex">{{item}}</li></ul>
  </section>

  <!-- Note written by the model: plain text, never trusted, under the facts (RT-21) -->
  <div *ngIf="!compact && action.note" class="ac-note">
    <p class="note-label">Note de {{action.client ? 'Claude' : 'l’Agent IA'}} (non vérifiée)</p>
    <p class="note-text">{{action.note}}</p>
  </div>
  <ng-content select="[cardNote]"></ng-content>

  <ul *ngIf="showExecutions && action.executions as executions" class="ac-executions" aria-label="Résultat par destinataire">
    <li *ngFor="let item of executions.items; trackBy: trackIndex" [ngClass]="'execution-' + item.status">
      <i class="pi" [ngClass]="item.status === 'sent' ? 'pi-check' : item.status === 'failed' || item.status === 'stale' ? 'pi-times-circle' : 'pi-spin pi-spinner'" aria-hidden="true"></i>
      <span class="execution-name">{{item.name}}</span>
      <span class="execution-status">{{item.statusLabel}}<span *ngIf="item.reason"> : {{item.reason}}</span></span>
    </li>
  </ul>
  <p *ngIf="outcome" class="ac-outcome" role="status" [ngClass]="'tone-' + tone">{{outcome}}</p>

  <ng-content select="[cardGestures]"></ng-content>
</article>
